/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React, { Fragment, useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle, Button, Alert,
  CardHeader, Popover, PopoverHeader, PopoverBody, Modal,
} from 'reactstrap';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import {
  Formik, Field, Form,
} from 'formik';
import * as Yup from 'yup';
import { get, post } from '../../helpers/api_helper';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import BaseGrid from '../../components/Common/BaseGrid';
// Import your Redux action
import { changeSidebarType } from '../../store/actions';
import OrderExportModal from '../../components/Sale/OrderExportModal';
import Tracking from '../../components/Sale/Tracking';
import HappyReturns from '../../components/HappyReturns/Sale';
import BestBuyReturn from '../../components/BestBuy/return';
import PartnerApiReturn from '../../components/PartnerApi/return';
import SaleRefundPanel from '../../components/Sale/Refunds';
import SaleInvoices from '../../components/Sale/Invoices';
import SaleData from '../../components/BigCommerce/SaleData';
import ChannelAdvisorSaleData from '../../components/ChannelAdvisor/SaleData';

import paidImg from '../../assets/images/small/paid.png';

function Sale(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const history = useHistory();

  const { t } = props;
  const { id: routeId } = useParams();
  const { saleId, embedded, onSaleChange } = props;
  const id = saleId ?? routeId;

  const [loading, setLoading] = useState(true);
  const [patching, setPatching] = useState(false);
  const [resettingQuickbooks, setResettingQuickbooks] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [sale, setSale] = useState(null);
  const [signal, setSignal] = useState(0);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [popoverData, setPopoverData] = useState(false);
  const [manuallyConcludeConfirm, setManuallyConcludeConfirm] = useState(false);

  const fetchSale = async () => {
    try {
      setLoading(true);
      const ent = await get(`/api/sales/${id}`);

      if (ent === '') {
        setSale(null);
      } else {
        setSale(ent);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const patchSale = async (values) => {
    try {
      setPatching(true);
      const result = await post(`/api/sales/save/${id}`, values);

      toastr.success(t(`Sale ID ${result.id} saved`), t('Success'));
    } catch (e) {
      setError(e.message);
    } finally {
      setPatching(false);
    }
  };

  const resetQuickbooks = async () => {
    if (!confirm(t('Clear all QuickBooks export fields for this sale, its invoices, and its credits? The next sync will reconcile with QuickBooks before resending.'))) return;

    try {
      setResettingQuickbooks(true);
      await post(`/api/sales/${id}/quickbooks/reset`, {});
      toastr.success(t('QuickBooks export state reset'), t('Success'));
      setSignal((current) => current + 1);
    } catch (e) {
      toastr.error(e.message, t('Could not reset QuickBooks export state'));
    } finally {
      setResettingQuickbooks(false);
    }
  };

  const isAdmin = props.user?.roles?.some((role) => ['Admin', 'Super Admin'].includes(role));

  const next = () => {
    if (embedded) onSaleChange(Number(id) + 1);
    else history.push(`/sales/${Number(id) + 1}`);
  };

  const prev = () => {
    if (embedded) onSaleChange(Number(id) - 1);
    else history.push(`/sales/${Number(id) - 1}`);
  };

  const viewExport = (row) => {
    // toastr.info(`Viewing distribution ${row.id}`);

    setPopoverOpen(row.id === popoverData.id ? !popoverOpen : true);
    setPopoverData(row);
  };

  const deleteExport = async (row) => {
    try {
      await post('/api/sales/distribution/delete', { id: row.id });
      setSignal(signal + 1);
      setPopoverOpen(false);
    } catch (err) {
      toastr.error(props.t('Could not delete export'));
      toastr.error(err.message);
    }
  };

  useEffect(() => {
    fetchSale();
    // props.changeSidebarType('icon');
  }, [id, signal]);

  return (
    <div className={embedded ? 'returns-sale-pane' : 'page-content'}>
      {!embedded && <Breadcrumbs title="Sales" prevLink="/sales" breadcrumbItem={`Manage Sale ID ${id}`} />}

      <div className="container-fluid">
        <Row>
          <Col xl="10">
            <Row>
              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody className="position-relative">
                    {sale !== null && sale.is_paid === 1 && (
                      <div
                        style={{
                          backgroundImage: `url(${paidImg})`,
                          backgroundSize: 'contain',
                          backgroundPosition: 'right',
                          backgroundRepeat: 'no-repeat',
                          position: 'absolute',
                          width: '30%',
                          height: '100%',
                          top: '-4px',
                          right: '20px',
                        }}
                      />
                    )}

                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Total')}
                        </p>
                        <h4 className="mb-0">{sale !== null ? `${sale.total_paid} ${sale.currency_code}` : '-'}</h4>
                      </div>

                      {sale !== null && sale.is_paid === 0 && (
                        <div className="align-self-center p-2 bg-danger text-white fs-4">
                          <strong>{t('UNPAID')}</strong>
                        </div>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Shipping Paid')}
                        </p>
                        <h4 className="mb-0">{sale !== null ? `${sale.shipping_paid} ${sale.currency_code}` : '-'}</h4>
                      </div>

                      <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                        <span className="avatar-title">
                          <i
                            className="mdi mdi-truck-check font-size-24"
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Tax Paid')}
                        </p>
                        <h4 className="mb-0">{sale !== null ? `${sale.sale_tax_paid} ${sale.currency_code}` : '-'}</h4>
                      </div>

                      <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                        <span className="avatar-title">
                          <i
                            className="fas fa-balance-scale-left font-size-24"
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-2">
                          {t('Sale Discount')}
                        </p>
                        <h4 className="mb-0">{sale !== null ? `${sale.discount} ${sale.currency_code}` : '-'}</h4>
                      </div>

                      <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                        <span className="avatar-title">
                          <i
                            className="mdi mdi-calculator font-size-24"
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        {sale !== null && (
          <>
            {sale.platform === 'BigCommerce' && (
              <HappyReturns reference={sale} />
            )}
            {sale.platform === 'Fidelitone' && (
              <BestBuyReturn reference={sale} onUpdated={() => { setSignal(signal + 1); }} />
            )}
            <PartnerApiReturn reference={sale} onUpdated={() => { setSignal(signal + 1); }} />
            <Row>
              <Col xl="5">
                <SaleRefundPanel sale={sale} reload={signal} />
                <SaleInvoices sale={sale} />
              </Col>
              <Col xl="7">
                <Tracking sale={sale} reload={signal} />
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col xl="4">
            {loading !== true && sale !== null && sale.canceled_at !== null && (
              <Alert color="danger">{t('Sale has been canceled')}</Alert>
            )}

            <Card>
              <CardBody>
                <div className="btn-group float-end mb-3">
                  <Button color="light" size="sm" title={t('Previous Sale')} onClick={prev}>
                    <i className="fa fa-chevron-left" />
                  </Button>
                  <Button color="light" size="sm" title={t('Next Sale')} onClick={next}>
                    <i className="fa fa-chevron-right" />
                  </Button>
                </div>

                <CardTitle className="h4">{`${t('Sale')} ${sale !== null ? sale.id : '-'}`}</CardTitle>
                {error !== null && (
                  <p className="text-danger">{error}</p>
                )}
                {error === null && (
                  <div className="table-responsive" style={{ clear: 'both' }}>
                    <table className="table table-bordered table-striped mt-3">
                      <tbody>
                        <tr>
                          <th>{t('Imported')}</th>
                          <td>
                            <small>{loading !== true && sale !== null && moment(sale.created_at).format('ddd, M/D/YYYY h:mma')}</small>
                            <br />
                            <small>
                              <strong>{loading === true || sale === null ? t('...') : moment(sale.created_at).fromNow()}</strong>
                            </small>
                          </td>
                        </tr>
                        <tr>
                          <th>{t('Reference 1')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.reference1}</td>
                        </tr>
                        <tr>
                          <th>{t('Reference 2')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.reference2}</td>
                        </tr>
                        <tr>
                          <th>{t('Platform')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.platform}</td>
                        </tr>
                        <tr>
                          <th>{t('Site')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.site}</td>
                        </tr>
                        <tr>
                          <th>{t('Customer Email')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.customer_email}</td>
                        </tr>
                        <tr>
                          <th>{t('Preferred Service')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.preferred_ship_method}</td>
                        </tr>
                        <tr>
                          <th>{t('Payment Method')}</th>
                          <td>{loading === true || sale === null ? t('...') : sale.payment_method}</td>
                        </tr>
                        <tr>
                          <th>{t('QuickBooks')}</th>
                          <td>
                            {sale?.quickbooks_transaction_id || t('Not exported')}
                            {sale?.quickbooks_last_error && (
                              <div className="text-danger mt-1">
                                <small>{sale.quickbooks_last_error}</small>
                              </div>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                {sale !== null && sale.platform === 'BigCommerce' && (
                  <div className="mt-2 mb-3">
                    <SaleData reference={sale.reference1} />
                  </div>
                )}

                {sale !== null && sale.platform === 'Rithum' && (
                  <div className="mt-2 mb-3">
                    <ChannelAdvisorSaleData
                      reference={sale.reference1}
                      customerEmail={sale.customer_email}
                    />
                  </div>
                )}

                <div className="hstack gap-2">
                  {sale !== null && isAdmin && (
                    <Button
                      color="warning"
                      size="sm"
                      disabled={resettingQuickbooks}
                      onClick={resetQuickbooks}
                    >
                      {resettingQuickbooks ? t('Resetting QuickBooks...') : t('Reset QuickBooks Export')}
                    </Button>
                  )}
                  {sale !== null && sale.manually_concluded_at === null
                    && sale.canceled_at === null && (
                      <div className="hstack gap-2">
                        {sale.shipped_at !== null && sale.fully_shipped_at === null && (
                          <Button onClick={() => { setManuallyConcludeConfirm(true); }} color="danger" size="sm">
                            {t('Conclude Sale')}
                          </Button>
                        )}
                        {['Partner API', 'Fidelitone'].includes(sale.platform)
                          && sale.shipped_at === null
                          && (
                            <button
                              type="button"
                              className="btn btn-dark btn-sm"
                              onClick={async () => {
                                try {
                                  if (confirm(t('Are you sure you want to cancel this sale?'))) {
                                    await patchSale({ canceled_at: new Date(Date.now()) });
                                    setSignal(signal + 1);
                                  }
                                } catch (err) {
                                  toastr.error(err.message, t('Error canceling sale'));
                                }
                              }}
                            >
                              {t('Cancel Sale')}
                            </button>
                          )}
                      </div>
                  )}
                </div>
              </CardBody>
            </Card>

            {loading !== true && sale !== null && (
              <Card>
                <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Staff Notes')}</CardHeader>
                <CardBody>
                  <Formik
                    enableReinitialize
                    initialValues={{ staff_note: sale.staff_note }}
                    validationSchema={Yup.object().shape({
                      staff_note: Yup
                        .string(),
                    })}
                    onSubmit={patchSale}
                  >
                    {({
                      errors, setFieldValue,
                    }) => (
                      <Form id="SaleForm" autoComplete="off">
                        {Object.entries(errors).length > 0 && (
                          <Alert color="danger">{t('Form contains errors')}</Alert>
                        )}
                        <div className="mb-3">
                          <Field className="form-control" id="staff_note" as="textarea" name="staff_note" onChange={(e) => { setFieldValue('staff_note', e.target.value); }} />
                        </div>

                        <Button type="submit" color="light" className="float-end bg-light text-dark" disabled={patching}>{patching ? t('Saving...') : t('Save')}</Button>
                      </Form>
                    )}
                  </Formik>
                </CardBody>
              </Card>
            )}
          </Col>
          <Col xl="8">
            <Row>
              <Col xl="4">
                {sale !== null && (
                  <div>
                    <Card>
                      <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Billing Address')}</CardHeader>
                      <CardBody>
                        <div className="float-end" style={{ width: '48px', height: '48px' }}>
                          <span className="avatar-title rounded-circle bg-soft bg-info text-dark font-size-24">
                            <span className="mdi mdi-card-account-details-outline" />
                          </span>
                        </div>

                        <address>
                          <strong>{`${sale.billing_firstname} ${sale.billing_lastname}`}</strong>
                          <br />
                          <span>{sale.billing_address1}</span>
                          <br />
                          {sale.billing_address2 && (
                            <>
                              <span>{sale.billing_address2}</span>
                              <br />
                            </>
                          )}
                          <span>{`${sale.billing_city} ${sale.billing_region} ${sale.billing_postcode}`}</span>
                          <br />
                          <span>{sale.billing_country}</span>

                          <br />
                          <br />
                          <span className="mdi mdi-office-building-marker" />
                          {' '}
                          <span>{sale.billing_company ? sale.billing_company : '--'}</span>
                          <br />
                          <span className="mdi mdi-phone" />
                          {' '}
                          <span>{sale.billing_phone ? sale.billing_phone : '--'}</span>
                          <br />
                        </address>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Shipping Address')}</CardHeader>
                      <CardBody>
                        <div className="float-end" style={{ width: '48px', height: '48px' }}>
                          <span className="avatar-title rounded-circle bg-success bg-soft text-dark font-size-24">
                            <span className="mdi mdi-card-account-details-outline" />
                          </span>
                        </div>

                        <address>
                          <strong>{`${sale.shipping_firstname} ${sale.shipping_lastname}`}</strong>
                          <br />
                          <span>{sale.shipping_address1}</span>
                          <br />
                          {sale.shipping_address2 && (
                            <>
                              <span>{sale.shipping_address2}</span>
                              <br />
                            </>
                          )}
                          <span>{`${sale.shipping_city} ${sale.shipping_region} ${sale.shipping_postcode}`}</span>
                          <br />
                          <span>{sale.shipping_country}</span>

                          <br />
                          <br />
                          <span className="mdi mdi-office-building-marker" />
                          {' '}
                          <span>{sale.shipping_company ? sale.shipping_company : '--'}</span>
                          <br />
                          <span className="mdi mdi-phone" />
                          {' '}
                          <span>{sale.shipping_phone ? sale.shipping_phone : '--'}</span>
                          <br />
                        </address>
                      </CardBody>
                    </Card>

                    {sale.customer_note !== null && sale.customer_note !== '' && (
                      <Alert color="warning">
                        <strong>{t('Customer note:')}</strong>
                        {' "'}
                        {sale.customer_note}
                        &quot;
                      </Alert>
                    )}
                  </div>
                )}
              </Col>

              <Col xl="8">
                <Card>
                  <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Items')}</CardHeader>
                  <CardBody>
                    {sale !== null && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>{t('Sold Listing')}</th>
                              <th>{t('ID')}</th>
                              <th>{t('SKU')}</th>
                              <th>{t('Paid ea.')}</th>
                              <th>{t('Qty')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sale && sale.items && sale.items.map((item) => (
                              <Fragment key={item.id}>
                                <tr>
                                  {item.listing !== null && (
                                    <td colSpan="5" className="text-dark">{item.listing.title}</td>
                                  )}
                                </tr>
                                <tr>
                                  <td>
                                    {item.listing !== null && (
                                      <img src={`/api/listings/thumbnail/${item.listing.id}`} style={{ maxWidth: '5rem', maxHeight: '5rem' }} alt="thumb" className="rounded" />
                                    )}
                                  </td>
                                  <td>{item.id}</td>
                                  <td>
                                    {item.listing === null ? '-' : ''}
                                    {item.listing !== null && (
                                      <a href={`/listing/${item.listing.id}`}>
                                        {item.listing.sku}
                                      </a>
                                    )}
                                  </td>
                                  <td>
                                    {item.paid}
                                    {' '}
                                    {sale.currency_code}
                                  </td>
                                  <td>{item.qty}</td>
                                </tr>
                              </Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </CardBody>
                </Card>

                <Card>
                  <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Distribution')}</CardHeader>
                  <CardBody>
                    {sale !== null && (
                      <BaseGrid
                        url="/api/sales/distribution"
                        filters={`sale_id=${sale.id}`}
                        shouldUpdate={signal}
                        create={() => { setExportModalOpen(true); }}
                        createText={t('Manual')}
                        config={
                          {
                            columns: {
                              destination: {
                                label: t('Source'),
                                html: true,
                                format: (f, x) => (
                                  x.items.find(
                                    (y) => y.original_substituted_item_id !== null,
                                  ) === undefined
                                    ? f : `${f}<br /><span class="badge bg-danger text-white fs-6 mt-1">${t('Substituted')}</span>`
                                ),
                              },
                              items: {
                                label: t('Items'),
                                format: (x) => x.reduce(
                                  (acc, cv) => acc + cv.qty,
                                  0,
                                ),
                              },
                              exported: {
                                label: 'Exported',
                                sort: false,
                                html: true,
                                format: (x) => {
                                  if (x === 1) {
                                    return '<span class="mdi mdi-checkbox-marked-outline text-dark fs-3" />';
                                  }

                                  return '<span class="mdi mdi-checkbox-blank-outline text-dark fs-3" />';
                                },
                              },
                              exported_at: {
                                label: t('At'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                              },
                              actions: {
                                label: props.t('Actions'),
                                actions: [
                                  {
                                    key: 'view',
                                    icon: 'mdi mdi-eye',
                                    class: 'btn btn-sm btn-info btn-soft-info',
                                    alt: props.t('View'),
                                    click: viewExport,
                                  },
                                  {
                                    key: 'delete',
                                    icon: 'mdi mdi-close-thick',
                                    class: 'btn btn-sm btn-danger',
                                    alt: props.t('Delete Export'),
                                    click: deleteExport,
                                    condition: (x) => x.exported === 0 || x.exported === null,
                                  },
                                ],
                              },
                            },
                            pagination: {
                              sort: 'id',
                              direction: 'desc',
                              perPage: 30,
                            },
                          }
                        }
                      />
                    )}
                  </CardBody>

                  {popoverData !== false && (
                    <Popover
                      key={popoverData.id}
                      placement="left"
                      isOpen={popoverOpen}
                      target={`act_btn_${popoverData.id}_view`}
                      className="sales-order-popover"
                      toggle={() => {
                        setPopoverOpen(!popoverOpen);
                      }}
                    >
                      <PopoverHeader>
                        {t('Ordered Items')}
                      </PopoverHeader>
                      <PopoverBody style={{ fontSize: '14px' }}>
                        {popoverData.items.map((item) => (
                          <div className="mb-2" key={item.id}>
                            {item.original_substituted_item_id !== null && (
                              <>
                                <span className="mdi mdi-swap-horizontal text-danger" />
                                {' '}
                              </>
                            )}
                            <span>{item.item.manufacturer}</span>
                            {' '}
                            <Link to={`/item/${item.item.id}`}>{item.item.part_number}</Link>
                            <br />
                            <div className="badge bg-info">{item.item.condition}</div>
                            {' X '}
                            {item.qty}
                          </div>
                        ))}
                      </PopoverBody>
                    </Popover>
                  )}
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        <OrderExportModal
          shown={exportModalOpen}
          sale={sale}
          onClose={() => { setExportModalOpen(false); }}
          onSuccess={() => { setSignal(signal + 1); setExportModalOpen(false); }}
        />

        <Modal isOpen={manuallyConcludeConfirm} size="sm">
          <div className="modal-header">
            <h5
              className="modal-title mt-0"
              id="manualModalLabel"
            >
              {t('Manually Conclude Order')}
            </h5>
            <button
              onClick={() => { setManuallyConcludeConfirm(false); }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <h4>
              {t('Are you sure you want to conclude this order?')}
            </h4>
            <p className="text-muted">
              {t('Conclude only when the order cannot be fulfilled any further')}
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => { setManuallyConcludeConfirm(false); }}
              className="btn btn-soft-dark"
              data-dismiss="modal"
            >
              {t('Cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={async () => {
                try {
                  await patchSale({ manually_concluded_at: new Date(Date.now()) });

                  setSignal(signal + 1);
                  setManuallyConcludeConfirm(false);
                } catch (err) {
                  toastr.error(err.message, t('Error concluding sale'));
                }
              }}
            >
              {t('Confirm')}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
}

Sale.defaultProps = {
  saleId: null, embedded: false, onSaleChange: () => {}, user: null,
};

Sale.propTypes = {
  saleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  embedded: PropTypes.bool,
  onSaleChange: PropTypes.func,
  user: PropTypes.shape({
    roles: PropTypes.arrayOf(PropTypes.string),
  }),
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  // changeSidebarType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({ ...state.Layout, user: state.Login.user });

export default connect(mapStateToProps, {
  changeSidebarType,
})(withTranslation()(Sale));
